module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('apartment-number-field', {
    attrs: {
      "error": _vm.$attrs.errors.apartment.number
    },
    model: {
      value: (_vm.$attrs.apartment.number),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.apartment, "number", $$v)
      },
      expression: "$attrs.apartment.number"
    }
  }), _vm._v(" "), _c('block-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.formType == 'add' && _vm.$attrs.apartment.block)),
      expression: "!(formType == 'add' && $attrs.apartment.block)"
    }],
    attrs: {
      "error": _vm.$attrs.errors.apartment.block
    },
    model: {
      value: (_vm.$attrs.apartment.block),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.apartment, "block", $$v)
      },
      expression: "$attrs.apartment.block"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c49a745","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/apartment/ApartmentBlankForm.vue
// module id = 637
// module chunks = 0